import React, { Component } from 'react'

import * as actions from "../actions";
import SimpleModal from "../../common/components/simple-modal";

import update from 'immutability-helper';

const DeleteOptionLink = React.createClass({
  getInitialState: function() {
    return { isModalOpen: false };
  },
  render: function() {
    const { heading, body } = this.props;
    return (
      <a onClick={this.openModal} className="delete-item">
        <i className="icon-cancel"></i>
        <SimpleModal
          isOpen={this.state.isModalOpen}
          onCloseClick={this.closeModal}
          modalId="delete-poll-option"
          modalClassName="delete-item"
          centered={true}
        >
          <h1>{heading}</h1>
          <p>{body}</p>
          <button onClick={this.closeModal} className="button-primary-inverse">
            Cancel
          </button>
          <button onClick={this.onConfirmClick} className="button-primary">
            Yes, I'm sure
          </button>
        </SimpleModal>
      </a>
    )
  },
  onConfirmClick: function(e) {
    e.preventDefault();
    this.props.onConfirmClick(this.props.key);
    this.setState({ isModalOpen: false });
  },
  openModal: function() {
    if (this.props.option.response_count > 0) {
      this.setState({isModalOpen: true});
    } else {
      this.setState({ isModalOpen: false });
      this.props.onConfirmClick(this.props.key);
    }

  },
  closeModal: function() {
    this.setState({ isModalOpen: false });
  }
})

const CreateEditPoll = React.createClass({
  getInitialState: function() {
    if (this.props.poll) {
      // save the initial state of the component for the cancel button
      this.initPollState = {};
      Object.assign(this.initPollState, this.props.poll, {editingPoll: false});
      return Object.assign(this.props.poll, {
        minOptions: this.props.poll.allow_other_options ? 1 : 2,
        maxOptions: 20,
        validationErrors: {},
        btnDisabled: false })
    } else {
      return {
        editingPoll: false,
        allow_other_options: false,
        question: '',
        options: [
          {option: ''},
          {option: ''}
        ],
        minOptions: 2,
        maxOptions: 20,
        validationErrors: {},
        btnDisabled: false
      }
    }
  },

  render: function() {
    const { editingPoll, question, options, minOptions, maxOptions } = this.state;
    const showAddOptionLink = options.length < maxOptions;
    const disable_options = showAddOptionLink ? false : "disabled";
    const option_nodes = options.map((opt, i) => {
      const { option, response_count, autofocus } = opt;
      const optionNum = i + 1;
      const inputRequired = optionNum <= minOptions;
      const canRemove = options.length > minOptions;
      return (
        <fieldset key={`poll-create-${ i }`}>
          <label>
            <span>Option { optionNum }</span>
            <input type="text"
              value={ option }
              onChange={ this.handleOptionChange.bind(this, i) }
              onKeyDown={ this.handleOptionKeyDown.bind(this, i) }
              maxLength="140"
              required={ inputRequired }
              tabIndex={ optionNum }
              autoFocus={ autofocus }
              disabled={ response_count > 0 ? "disabled" : false }
            />
            { canRemove &&
              <DeleteOptionLink
                  heading="Are you sure?"
                  body="This poll choice has votes, are you sure you would like to remove it?"
                  onConfirmClick={ this.handleRemoveOption.bind(this, i) }
                  option={ options[i] }
                  key={ i }
              />
            }
            <span className="option-responses" >{ response_count }</span>
          </label>
        </fieldset>
      )
    });
    return (
      <div className="polls create-poll simple-shadowbox">
        <h3>Create a Poll</h3>
        <form onSubmit={this.handleFormSubmit}>
          <input
            type="text"
            placeholder="Your question"
            value={question}
            onChange={this.handleQuestionChange}
            maxLength="140"
            required
            tabIndex="1"
          />
          {option_nodes}
          <div className="btn-container">
            { showAddOptionLink &&
              <a href="#" onClick={this.handleAddClick}>
                Add Another Option
              </a>
            }
            <fieldset id="allow_options_fieldset" style={ { 'marginTop': '15px', 'textAlign': 'left'} }>
              <input
                type="checkbox"
                disabled={ disable_options }
                id="allow_other_options"
                checked={ this.state.allow_other_options }
                onChange={ this.handleCheckboxChange }
              />
              <label htmlFor="allow_other_options">
                <span></span>
                Other - Check to allow guests to add custom options to this poll.
              </label>
              { (this.state.validationErrors.maxOptions ||this.state.validationErrors.minOptions) &&
                <span className="validation-error" style={ {marginTop: '15px', display: 'block'} }>
                  { this.state.validationErrors.minOptions }
                  { this.state.validationErrors.maxOptions }
                </span>
              }
            </fieldset>
            { editingPoll &&
              <input
                onClick={ this.handleCancelClick}
                type="button"
                className="button-secondary-inverse"
                value="Cancel"
              />
            }
            <input
              type="submit"
              value={ editingPoll ? "Save Changes" : "Create Poll" }
              className="button-primary-inverse"
              disabled={ this.state.btnDisabled }
            />
          </div>
        </form>
      </div>
    )
  },

  handleFormSubmit: function(e) {
    e.preventDefault();
    const { editingPoll, question, options } = this.state;
    let optionsArray = [];
    options.map((option, i) => {
      if (option.option) {
        optionsArray.push(option);
      }
    });
    if (!question || optionsArray.length < this.state.minOptions) {
      this.setState({
        validationErrors: {
          minOptions: 'At least 2 poll choices are required, including the option to allow guests to add a custom choice.'
        }
      });
      return false;
    }
    const strOptionsArray = JSON.stringify(optionsArray);
    if (editingPoll) {
      const data = {
        question,
        id: this.state.id,
        allow_other_options: this.state.allow_other_options,
        options: strOptionsArray
      };
      actions.savePoll(data);
      this.setState({ btnDisabled: true })
    } else {
      const data = {
        question,
        allow_other_options: this.state.allow_other_options,
        options: strOptionsArray
      };
      actions.createPoll(data);
      this.setState({ btnDisabled: true })
    }
  },

  handleQuestionChange: function(e) {
    const newState = update(this.state, {
      question: {$set: e.target.value}
    });
    this.setState(newState);
  },

  handleOptionChange: function(index, e) {
    const newState = update(this.state, {
      options: {
        [index]: {
          option: {$set: e.target.value}
        }
      }
    });
    this.setState(newState);
  },

  handleCheckboxChange: function(e) {
    this.setState({
      allow_other_options: !this.state.allow_other_options,
      minOptions: this.state.allow_other_options ? 2 : 1
    });
  },

  handleOptionKeyDown: function(index, e) {
    const optionsLen = this.state.options.length;
    if (e.keyCode === 9 && !e.shiftKey && index + 1 === optionsLen) {
      e.preventDefault();
      this.handleAddClick(e);
    }
  },

  handleAddClick: function(e) {
    e.preventDefault();
    if (this.state.options.length === this.state.maxOptions) {
      this.setState({
        validationErrors: {
          maxOptions: 'The maximum number of poll choices is 20'
        }
      });
      return false;
    }
    const newState = update(this.state, {
      options: {$push: [{
        option: '',
        autofocus: true
      }]}
    });
    this.setState(newState);
  },

  handleRemoveOption: function(index) {
    const filtered = this.state.options.filter(function(opt, i) {
      return i !== index;
    });
    const newState = update(this.state, {
      options: {$set: filtered}
    });
    this.setState(newState);
  },

  handleCancelClick: function(e) {
    actions.cancelEditPoll(this.initPollState);
  },


});



export default CreateEditPoll;



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/polls/components/create-edit-poll.es6